module.exports = __webpack_public_path__ + "static/flex-73b0fff29fc5538ae172ae31947af3c2.pdf";